export default __webpack_public_path__ + "static/media/BTN 2.f8baaaf8.svg";